import React from 'react';
import IconButtonBase from './IconButtonBase';
import { TIconButton } from './types';

const Secondary = ({ as = 'button', ...rest }: TIconButton) => <IconButtonBase {...rest} as={as} kind="secondary" />;

export default Secondary;
